/**
 * The single placement law (2026-05): the protagonist stands on the LEFT lane,
 * everyone else on the RIGHT. When the protagonist is unknown (`null`), returns
 * the caller's `fallback` lane so each consumer keeps its own legacy behavior.
 *
 * Callers normalize `character` and `protagonist` to a comparable slug form
 * before calling:
 *   - ls-preview `reduce.ts` (`forcedSlotFor`): `character` already arrives
 *     compiler-slugged; passes through. `fallback` = the script's normalized
 *     position.
 *   - F Studio `apply-character.ts`: slugifies the authored token first; only
 *     calls this when a protagonist is set, so its `fallback` is never hit.
 *
 * THIS IS THE SINGLE MOST IMPORTANT CORRECTNESS RULE and must not drift — it
 * now lives in exactly one place (was duplicated as `forcedSlotFor` +
 * `isProtagonist`).
 */
export function placeCharacter(character, protagonist, fallback) {
    if (!protagonist)
        return fallback;
    return character === protagonist ? "left" : "right";
}
